import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { UserPermissionService } from '../../services/user/user-permission.services';

@Injectable({
  providedIn: 'root',
})
export class NotAuthorizedRedirectGuard implements CanActivate {
  constructor(private userPermissionService: UserPermissionService) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.userPermissionService.userPermissions$.pipe(
      filter((permissions) => permissions !== undefined),
      take(1),
      map((permissions) => {
        if (permissions.length === 0) {
          return true; // no permissions — stay on not-authorized
        }
        const navigated = this.userPermissionService.navigateToDefaultRoute(permissions);
        return !navigated; // if no matching route found, stay on not-authorized
      })
    );
  }
}
